export default __webpack_public_path__ + "static/media/credit_Application.d8249c96.pdf";